export default __webpack_public_path__ + "static/media/AngelHair_T.4b893c4c.jpg";